import { render } from "./UploadVolume.vue?vue&type=template&id=632e3b72&scoped=true"
import script from "./UploadVolume.vue?vue&type=script&lang=js"
export * from "./UploadVolume.vue?vue&type=script&lang=js"

import "./UploadVolume.vue?vue&type=style&index=0&id=632e3b72&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632e3b72"]])

export default __exports__